export const getElementsByKey = ({ objectsArray, key, value }) => {
    const index = objectsArray?.findIndex(obj => obj[key] === value);

    const current = objectsArray?.[index]
    const previous = objectsArray?.[index - 1]
    const next = objectsArray?.[index + 1]

    return {
        previous,
        current,
        next
    }
}